 <template>
  <div>
    <v-card>
      <v-toolbar v-if="actionName === 'new'" dense color="grey lighten-3" flat>
        <v-icon>mdi-plus</v-icon>
        <v-toolbar-title>New {{ dialogTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar v-if="actionName === 'review'" dense color="grey lighten-3" flat>
        <v-icon>mdi-pencil</v-icon>
        <v-toolbar-title>Edit {{ dialogTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                :label="filterFormLabel.filterName"
                v-model="filterForm.filterName"
                :error-messages="errors.collect('filterName')"
                :hint="filterNameHint"
                persistent-hint
                data-vv-name="filterName"
                :data-vv-as="filterFormLabel.filterName"
                v-validate="'required|max:100'"
                :disabled="actionName === 'review'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-checkbox color="primary" :label="filterFormLabel.activeFlag" v-model="filterForm.activeFlag"></v-checkbox>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :label="filterFormLabel.filterDesc"
                v-model="filterForm.filterDesc"
                :error-messages="errors.collect('filterDesc')"
                data-vv-name="filterDesc"
                :data-vv-as="filterFormLabel.filterDesc"
                v-validate="'required|max:200'"
                :counter="200"
                :rows="3"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="closeDialog">Cancel</v-btn>
        <v-btn color="primary" text @click.native="doSaveFilter">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      filterForm: {
        filterName: '',
        filterDesc: '',
        filterCode: '',
        activeFlag: false,
        filterContent: ''
      },
      filterFormLabel: {
        filterName: 'Filter Name',
        filterDesc: 'Description',
        activeFlag: 'Set as default'
      },
      items: [],
      headers: [{ text: 'Name', value: 'filterName' }, { text: 'Description', value: 'filterDesc' }, TableConst.tableActionHeader]
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        if (this.actionName === 'new') {
          this.doNewFilter()
        } else {
          this.doReviewFilter()
        }
      }
    }
  },
  mounted() {
    if (this.actionName === 'new') {
      this.doNewFilter()
    } else {
      this.doReviewFilter()
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    reloadList() {
      this.$emit('reloadList', this.filterForm.filterName)
    },
    refreshList() {
      this.$emit('refreshList')
      this.closeDialog()
    },
    doNewFilter() {
      this.doResetFilterForm()
    },
    async doReviewFilter() {
      this.resetMessages()
      this.resetValidator()
      this.filterForm.activeFlag = this.activeFlag
      this.filterForm.filterName = this.filterName
      this.filterForm.filterCode = this.filterCode
      this.filterForm.filterDesc = this.filterDesc
    },
    doResetFilterForm() {
      this.resetMessages()
      this.resetValidator()
      var thisPage = this
      Object.keys(this.filterForm).forEach(function (key, index) {
        if (key === 'activeFlag') {
          thisPage.filterForm[key] = false
        } else {
          thisPage.filterForm[key] = ''
        }
      })
    },
    doSaveFilter() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.actionName === 'new') {
            this.doCreateFilter()
          } else {
            this.doUpdateFilter()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreateFilter() {
      const apiURI = this.$store.state.searchFilter.menu.createFilter
      if (apiURI) {
        this.filterForm.filterCode = this.filterCode
        this.filterForm.filterContent = JSON.stringify(this.filters)
        this.$http
          .post(apiURI, this.filterForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$toast.success('Filter successfully added.')
              if (this.filterForm.activeFlag) {
                this.reloadList()
              } else {
                this.closeDialog()
              }
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdateFilter() {
      const apiURI = this.$store.state.searchFilter.menu.updateFilter
      if (apiURI) {
        this.$http
          .put(apiURI, this.filterForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$toast.success('Filter successfully updated.')
              this.refreshList()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    filterNameHint() {
      return 'Enter a name for this filter'
    }
  },
  props: {
    filterCode: {
      type: String,
      default: ''
    },
    filterName: {
      type: String,
      default: ''
    },
    filterDesc: {
      type: String,
      default: ''
    },
    activeFlag: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    actionName: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default: null
    },
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
